module.exports = __webpack_public_path__ + "static/img/sp_banner1.c08a669.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sp/sp_banner1.png
// module id = RqZS
// module chunks = 0